/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { TimeframeLike } from './TimeframeLike';
const AssignmentSectionTimeframeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['sectionIds', /* #__PURE__ */ codecArray(codecString), 'section_ids'],
]), TimeframeLike);
export class AssignmentSectionTimeframe extends TimeframeLike {
    static decode(input) {
        return AssignmentSectionTimeframeParser.decode(input).map(res => new AssignmentSectionTimeframe(res));
    }
    static unsafeDecode(input) {
        return AssignmentSectionTimeframe.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentSectionTimeframeParser.encode(data);
    }
    static schema() {
        return AssignmentSectionTimeframeParser.schema();
    }
}
